import revive_payload_client_4sVQNw7RlN from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import components_plugin_KR1HBZs4kY from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_vue3_A0OWXRrUgq from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import chunk_reload_client_UciE0i6zes from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import moment_client_72mK1CThvW from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/plugins/moment.client.ts";
import vue_gtag_client_CYt6toK02h from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/plugins/vue-gtag.client.ts";
import vue_i18n_client_LvPrXiqsFD from "/Users/jason/git/bitbyte/playkeyboard/PlayKeyboard_Webview/plugins/vue-i18n.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_vue3_A0OWXRrUgq,
  chunk_reload_client_UciE0i6zes,
  moment_client_72mK1CThvW,
  vue_gtag_client_CYt6toK02h,
  vue_i18n_client_LvPrXiqsFD
]